import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsermanagementComponent } from './components/usermanagement/usermanagement.component';

const routes: Routes = [{
  path: '',
  redirectTo: '',
  pathMatch: 'full',
  component: UsermanagementComponent,
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsermanagementRoutingModule { }
